import { ObituaryPage } from 'routes/obituaries/Obituary';

import { Footer } from './Footer';
import { Header } from './Header';

export const FrontCreate = (props?: any) => {
  return (
    <div>
      <Header></Header>
      <div style={{ marginTop: '60px' }}>
        <ObituaryPage></ObituaryPage>
      </div>
      <Footer></Footer>
    </div>
  );
};
